export default [
  {
    path: '/content-manage',
    name: 'ContentManage',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: 'notice-manage/list',
        name: 'NoticeManageList',
        component: () => import('@/views/content-manage/notice-manage/list.vue'),
        meta: {
          title: '通知管理',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
